const DAY_MS = 24 * 60 * 60 * 1000;

const roundOne = (value: number) => Math.round(value * 10) / 10;

export function relativeChange(current: number, previous: number): number {
  if (previous === 0) return current === 0 ? 0 : 100;
  return roundOne(((current - previous) / previous) * 100);
}

export function percentagePointChange(current: number, previous: number): number {
  return roundOne(current - previous);
}

export function previousPeriod(start: Date, end: Date): { start: Date; end: Date } {
  const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const inclusiveDays = Math.max(
    1,
    Math.round((endDay.getTime() - startDay.getTime()) / DAY_MS) + 1,
  );
  const previousEnd = new Date(startDay);
  previousEnd.setDate(previousEnd.getDate() - 1);
  const previousStart = new Date(previousEnd);
  previousStart.setDate(previousStart.getDate() - inclusiveDays + 1);
  return { start: previousStart, end: previousEnd };
}
